import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableBillingManagement from "./components/TableBillingManagement";


function ManagementBillingRegisterPage() {
    return (
        <ToastProvider>
            <Dashboard>
              <TableBillingManagement/>
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default ManagementBillingRegisterPage